import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../providers/authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  public reset: FormGroup;
  public error: any;
  public success: boolean;
  constructor(public formBuilder: FormBuilder,
              public auth: AuthenticationService) {
    this.getReset();
  }


  getReset() {
    this.reset = this.formBuilder.group({
      email: ['', Validators.email]
    });
  }

  sendpass() {
    const form = this.reset.value;
    this.success = false;
    this.error = false;
    this.auth.resetPassword(form['email']).then( data => {
        this.success = true;
    }).catch( rejected => this.gestionError(rejected));
  }

  gestionError(log: any) {
    switch (log.code) {
      case 'auth/user-not-found':
        this.error = 'L\'adresse email indiqué n\'est pas enregistrer sur le site';
        break;
      case 'auth/invalid-email':
        this.error = 'Adresse email invalide';
        break;
      default:
        this.error = 'Une erreur c\'est produite';
        break;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/reset-password/reset-password.component.ts